import styled from "styled-components";
import { getDeviceType } from "@bracket/ui";
import { Flow, } from "@bracket/ui/nodes";




export const Spacer = ({
	space,
	device = "ALL",
}: { space?: string; device?: "MOBILE" | "DESKTOP" | "ALL" }) => {
	const deviceType = getDeviceType();
	return device === "ALL" || device === deviceType ? <FlexSpacer $space={space} /> : null;
};


const FlexSpacer = styled(Flow)<{ $space?: string }>`
	width: 100%;
	height: ${props => props.$space || "0"};
`;
